import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "17",
  height: "17",
  fill: "none",
  viewBox: "0 0 19 19"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("rect", {
  width: "17",
  height: "17",
  x: "1",
  y: "1",
  fill: "#fff",
  rx: "8.5"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("rect", {
  width: "17",
  height: "17",
  x: "1",
  y: "1",
  stroke: "#4C4DEE",
  "stroke-width": "2",
  rx: "8.5"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#0004E7",
  stroke: "#0004E7",
  "stroke-width": ".25",
  d: "M9.146 12.747a.9.9 0 0 1-.31-.052.7.7 0 0 1-.268-.174l-3.8-3.772a.78.78 0 0 1-.226-.574q0-.35.227-.574a.79.79 0 0 1 .578-.226q.351 0 .578.226l3.22 3.198L12.368 7.6a.79.79 0 0 1 .578-.226q.35 0 .578.226.227.225.227.574a.78.78 0 0 1-.227.574L9.724 12.52a.7.7 0 0 1-.268.174.9.9 0 0 1-.31.051Z"
}, null, -1)
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_5]))
}
export default { render: render }